<div>
    <div style="margin-left: 60%;  margin-bottom: 2%">
       
        <button *ngIf="updateStatus" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
            color="primary" (click)="saveSubscriptionPincodeStatewiseEntry()">
            save
        </button>
        <button *ngIf="!updateStatus" [disabled]="deleteDistrictwiseStatemet" class="noPrint"
            style="margin-right: 2%; margin-left: 2%;background-color: #f5365c;" mat-raised-button color="primary"
            (click)="deletePincodewiseStatementList()">
            delete
        </button>
        <button [useExistingCss]="true" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
            color="primary" printTitle="Pincodewise Statement" printSectionId="print-section" ngxPrint >
            print
        </button>
        <!-- <button mat-raised-button class="btn btn-info noPrint" (click)="print()"
                style="margin-right: 2%; margin-left: 2%">
                Print
            </button> -->
        <button mat-dialog-close class="btn noPrint">Close</button>
    </div>
    <div class="container" id="print-section">
        <div style="margin: 0px 15px;">
            <div class="row"
                style="text-align: center;border-width: 1px 1px 1px 1px; border-style: solid; border-color: black;padding-top: 05px; padding-bottom: 04px;">
                <span style=" font-size: 16px;font-weight: 600;margin: auto;">मा. विवेक, प्रभादेवी - २५ दि
                    {{sundayankDate}}
                    च्या
                    अंकाकरिता
                    पोस्ट स्टेटमेंट
                    वितरण दि {{dispatchankDate}}</span>
            </div>
            <div class="row">
                <div [ngClass]="!updateStatus?'col':'col12'" class=" noPrint" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;font-weight: 600;text-align: center;">
                    <label>
                        <input type="checkbox" [(ngModel)]="masterSelected" (change)="checkUncheckAll()" style="margin-right: 12px;"> All
                    </label>
                </div>
                <!-- <div  style="border-width: 0px 1px 1px 0px;font-weight: 600;">ALL</div> -->
                <div [ngClass]="!updateStatus?'col':'col12'"   class=" pl-2" style="text-align: left; border-width: 0px 1px 1px 1px;font-weight: 600;">राज्य </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;font-weight: 600;">पिनकोड</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;font-weight: 600;">वर्गणीदार संख्या</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;font-weight: 600;">पार्सल संख्या</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="text-align: left; border-width: 0px 1px 1px 0px;font-weight: 600;">राज्य </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;font-weight: 600;">पिनकोड</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;font-weight: 600;">वर्गणीदार संख्या</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;font-weight: 600;">पार्सल संख्या</div>


                <ng-container *ngFor="let data of pincodewisesubcoutprinting; let i=index">
                    <div  [ngClass]="!updateStatus?'col':'col12'"  class=" noPrint" *ngIf="!updateStatus" style="text-align: left; border-width: 0px 1px 1px 1px;text-align: center;"><span > 
                        <input type="checkbox" [(ngModel)]="data.selected" (change)="isAllSelected()" style="margin-right: 12px;">{{i+1}}</span>
                    </div>
                <div  [ngClass]="!updateStatus?'col':'col12'"  class=" pl-2" style="text-align: left; border-width: 0px 1px 1px 1px;"><span *ngIf="data['state1'] != ''">{{
                        data['state1']}}</span></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;"><span *ngIf="data['pincode1'] != 0">{{
                        data['pincode1']}}</span></div>
                <div  [ngClass]="!updateStatus?'col':'col12'"  style="border-width: 0px 1px 1px 0px;">
                    <span *ngIf="data['sub1'] != 0">{{
                        data['sub1']}}</span>
                </div>
                <div  [ngClass]="!updateStatus?'col':'col12'"  style="border-width: 0px 1px 1px 0px;"><span *ngIf="data['pincode1'] != 0">{{
                        data['parcel1']}}</span></div>
                <div [ngClass]="!updateStatus?'col':'col12'"  class=" pl-2" style="text-align: left;border-width: 0px 1px 1px 0px;"><span *ngIf="data['state2'] != ''">{{
                        data['state2']}}</span></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;"><span *ngIf="data['pincode2'] != 0">{{
                        data['pincode2']}}</span></div>
                <div  [ngClass]="!updateStatus?'col':'col12'"  style="border-width: 0px 1px 1px 0px;">
                    <span *ngIf="data['sub2'] != 0">{{
                        data['sub2']}}</span>
                </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;"><span *ngIf="data['pincode2'] != 0">{{
                        data['parcel2']}}</span></div>
                </ng-container>

                <div [ngClass]="!updateStatus?'col':'col12'"  class=" noPrint" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 1px;">एकूण</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">{{subTotal1}}</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">{{countBundleTotal1}}={{countBooksBundleTotal1}}</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">{{subTotal2}}</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">{{countBundleTotal2}}={{countBooksBundleTotal2}}</div>
           
                <div [ngClass]="!updateStatus?'col':'col12'"  class=" noPrint" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'" class=" noPrint" style="border-width: 0px 1px 1px 1px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'" class=" noPrint" style="border-width: 0px 1px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'" class=" noPrint" style="border-width: 0px 1px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'" class=" noPrint" style="border-width: 0px 1px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'" class=" noPrint" style="border-width: 0px 1px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'" class=" noPrint" style="border-width: 0px 1px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'" class=" noPrint" style="border-width: 0px 1px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'" class=" noPrint" style="border-width: 0px 1px 1px 0px;"> </div>


                <div [ngClass]="!updateStatus?'col':'col12'"  class=" noPrint" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width:0px 1px 1px 1px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">                </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">परप्रांत एकूण</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">
                    {{ total_pin_sub_count }}
                </div>
                <div [ngClass]="!updateStatus?'col':'col12'"  style="border-width: 0px 1px 1px 0px;">{{ totalparcel }}={{ totalanksankhya }}</div>
          


                <div [ngClass]="!updateStatus?'col':'col12'"  class=" noPrint" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 1px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 0px 1px 0px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 0px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 0px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">मुंबई एकूण</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">
                    {{ total_mumbai_pin_sub_count }}
                </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">
                    {{ totalmumbaiparcel }}={{ totalmumbaianksankhya }}
                </div>


                <div [ngClass]="!updateStatus?'col':'col12'"  class=" noPrint" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 1px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 0px 1px 0px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 0px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 0px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">ठाणे एकूण</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">
                    {{ total_thane_pin_sub_count }}
                </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">
                    {{ totalthaneparcel }}={{ totalthaneanksankhya }}
                </div>


                <div [ngClass]="!updateStatus?'col':'col12'"  class=" noPrint" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 1px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 0px 1px 0px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 0px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 0px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">जिल्हा एकूण</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">
                    {{ total_dist_pin_sub_count }}
                </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">
                    {{ totaldistparcel }}={{ totaldistanksankhya }}
                </div>

                <div [ngClass]="!updateStatus?'col':'col12'"  class=" noPrint" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;"></div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 1px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 0px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 0px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 0px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 0px 1px 0px;"> </div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 1px;"> एकूण</div>
                <div [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">
                    {{ total_pin_sub_count+total_mumbai_pin_sub_count+total_thane_pin_sub_count +
                    total_dist_pin_sub_count }}
                </div>
                <div  [ngClass]="!updateStatus?'col':'col12'"   style="border-width: 0px 1px 1px 0px;">
                    {{ totalparcel+totalmumbaiparcel+totalthaneparcel+totaldistparcel }}={{
                    totalanksankhya+totalmumbaianksankhya+totalthaneanksankhya+totaldistanksankhya }}
                </div>
            </div>
            
        </div>
    </div>
</div>

<style>
    @media print {
      .row {
        width: 100%;
        margin: 0 auto;
      }
    
      .col, .col12 {
        border-style: solid;
        border-color: black;
        text-align: center;
        font-weight: 500;
    
        /* Optional adjustments */
        width: 12.5%;       /* 100 / 8 for 8 columns */
        max-width: 12.5%;
        flex: 0 0 12.5%;
        padding-top: 5px;
        padding-bottom: 4px;
        box-sizing: border-box;
      }
    
      .noPrint {
        display: none !important;
      }
    }
    </style>
    